function scrollToTarget(el, target) {
    el.addEventListener("click", (e) => {
        e.preventDefault();
        gsap.to(window, {
            duration: 0.6,
            ease: "power4.easeInOut",
            scrollTo: { y: target }
        });
    });
}